{
  "familyId": "MET-GEW-SCHATTEN",
  "questions": [
    {
      "id": "MET-GEW-SCHATTEN-001",
      "familyId": "MET-GEW-SCHATTEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_schatten",
      "questionType": "estimation_slider",
      "question": "Een leerling tilt zijn volle schooltas op. Schat hoeveel kilogram de schooltas weegt.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "min": 0,
        "max": 20,
        "correctValue": 5,
        "tolerancePercent": 15,
        "unit": "kg",
        "showNumberLine": true,
        "showValue": false
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "weighScale",
          "showWhen": "wrong",
          "data": {
            "leftWeight": 5,
            "rightWeight": 5,
            "targetWeight": 5,
            "unit": "kg",
            "maxWeight": 20,
            "label": "Een volle schooltas weegt ongeveer 5 kg — vergelijk met 5 pakken melk."
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gewicht schatten — referentiepunten",
            "content": "Gebruik referentiepunten: een pak melk = 1 kg, een appel = 150 g, een schooltas = 3-7 kg, een volwassene = 60-90 kg. Een schooltas is zwaarder dan een pak melk maar lichter dan een kind.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "weight_estimate_schoolbag",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Een volle schooltas weegt ongeveer 3-7 kg, dus ~5 kg is een goede schatting. Dat is vergelijkbaar met 5 pakken melk. Hoe schat je gewicht? Vergelijk met iets dat je kent: een pak melk = 1 kg. Een schooltas met boeken voelt als 5 pakken melk.",
        "solutionSteps": [
          "Referentie: 1 pak melk = 1 kg",
          "Een schooltas = meerdere boeken + etui",
          "Schatting: 3-7 kg → ~5 kg",
          "Check: 5 pakken melk klinkt realistisch ✓"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.gewicht-schooltas-schatten-fout", "label": "Schat schooltasgewicht buiten realistische range" }
        ]
      }
    },
    {
      "id": "MET-GEW-SCHATTEN-002",
      "familyId": "MET-GEW-SCHATTEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_schatten",
      "questionType": "estimation_slider",
      "question": "Een boer weegt een volwassen koe. Schat hoeveel kilogram de koe weegt.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "min": 0,
        "max": 2000,
        "correctValue": 600,
        "tolerancePercent": 15,
        "unit": "kg",
        "showNumberLine": true,
        "showValue": false
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "weighScale",
          "showWhen": "wrong",
          "data": {
            "leftWeight": 600,
            "rightWeight": 600,
            "targetWeight": 600,
            "unit": "kg",
            "maxWeight": 2000,
            "label": "Een volwassen koe weegt ~600 kg — dat is 8× het gewicht van een mens."
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gewicht van dieren",
            "content": "Referentiepunten: een kat = 4 kg, een hond = 20-40 kg, een mens = 60-90 kg, een koe = 400-800 kg, een olifant = 4.000-6.000 kg. Een koe is veel zwaarder dan een mens maar lichter dan een olifant.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "weight_estimate_cow",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Een volwassen koe weegt ongeveer 400-800 kg, dus ~600 kg is een goede schatting. Dat is ongeveer 8 keer het gewicht van een volwassen mens (~75 kg). Hoe schat je dit? Vergelijk met bekende gewichten en werk stap voor stap omhoog.",
        "solutionSteps": [
          "Referentie: een mens = ~75 kg",
          "Een koe is veel groter dan een mens",
          "Schatting: 400-800 kg → ~600 kg",
          "Check: ~8 × een mens klinkt realistisch ✓"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.gewicht-koe-schatten-fout", "label": "Schat koegewicht buiten realistische range" }
        ]
      }
    },
    {
      "id": "MET-GEW-SCHATTEN-003",
      "familyId": "MET-GEW-SCHATTEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_schatten",
      "questionType": "multiple_choice",
      "question": "Welk voorwerp weegt ongeveer 100 gram?",
      "options": ["een fiets", "een appel", "een munt van 1 euro", "een stoel"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "weighScale",
          "showWhen": "wrong",
          "data": {
            "leftWeight": 100,
            "rightWeight": 100,
            "targetWeight": 100,
            "unit": "g",
            "maxWeight": 500,
            "label": "100 gram is het gewicht van een appel — voel het verschil met een munt (~7 g)."
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gewicht schatten — 100 gram",
            "content": "100 gram is een handvol. Referenties: een munt = ~7 g, een appel = 100-200 g, een brood = 500 g, een fiets = 10-15 kg, een stoel = 3-5 kg.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "weight_estimate_100g",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Een appel weegt ongeveer 100-200 gram. Een munt van 1 euro weegt maar ~7 gram (veel te licht). Een fiets weegt 10-15 kg (veel te zwaar). Een stoel weegt 3-5 kg (ook te zwaar).",
        "solutionSteps": [
          "100 gram = een handvol",
          "Een appel = 100-200 g ✓",
          "Een munt = ~7 g (te licht)",
          "Een fiets = 10-15 kg (te zwaar)"
        ],
        "distractorExplanations": {
          "0": "Een fiets weegt 10-15 kg, dat is 10.000-15.000 gram — veel meer dan 100 gram. Onthoud: 1 kg = 1.000 gram.",
          "1": "Goed! Een appel weegt ongeveer 100-200 gram.",
          "2": "Een munt van 1 euro weegt maar ~7 gram — veel minder dan 100 gram. Je zou 14 munten nodig hebben voor 100 gram. Onthoud: munten zijn heel licht.",
          "3": "Een stoel weegt 3-5 kg, dat is 3.000-5.000 gram — veel meer dan 100 gram. Onthoud: meubels wegen kilogrammen, niet grammen."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.gewicht-fiets-overschat-100g", "label": "Denkt dat fiets 100 g weegt (verwart kg en g)", "optionIndex": 0 },
          { "id": "met.gewicht-munt-overschat-100g", "label": "Denkt dat munt 100 g weegt", "optionIndex": 2 },
          { "id": "met.gewicht-stoel-onderschat-100g", "label": "Denkt dat stoel 100 g weegt (verwart kg en g)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-GEW-SCHATTEN-004",
      "familyId": "MET-GEW-SCHATTEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_schatten",
      "questionType": "multiple_choice",
      "question": "Zet deze voorwerpen op volgorde van licht naar zwaar.",
      "options": [
        "munt → schooltas → appel → fiets",
        "appel → munt → fiets → schooltas",
        "munt → appel → schooltas → fiets",
        "fiets → schooltas → appel → munt"
      ],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gewichten vergelijken",
            "content": "Munt = ~7 g, appel = ~150 g, schooltas = ~5 kg, fiets = ~12 kg. Van licht naar zwaar: munt → appel → schooltas → fiets.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "weight_estimate_ordering",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Van licht naar zwaar: munt (~7 g) → appel (~150 g) → schooltas (~5 kg) → fiets (~12 kg). Onthoud: gram-voorwerpen zijn lichter dan kilogram-voorwerpen.",
        "solutionSteps": [
          "Munt: ~7 gram (lichtst)",
          "Appel: ~150 gram",
          "Schooltas: ~5 kg = 5.000 gram",
          "Fiets: ~12 kg = 12.000 gram (zwaarst)"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat een schooltas lichter is dan een appel. Maar een schooltas weegt 3-7 kg, een appel ~150 g. Onthoud: schooltas > appel.",
          "1": "Je dacht waarschijnlijk dat een munt zwaarder is dan een appel. Maar een munt weegt ~7 g en een appel ~150 g. Onthoud: munt < appel.",
          "2": "Goed! Van licht naar zwaar: munt (~7 g) → appel (~150 g) → schooltas (~5 kg) → fiets (~12 kg).",
          "3": "Je dacht waarschijnlijk dat de volgorde omgekeerd is. Maar de vraag is van licht naar zwaar, niet van zwaar naar licht."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.gewicht-volgorde-schooltas-appel", "label": "Denkt dat schooltas lichter is dan appel", "optionIndex": 0 },
          { "id": "met.gewicht-volgorde-munt-appel", "label": "Denkt dat munt zwaarder is dan appel", "optionIndex": 1 },
          { "id": "met.gewicht-volgorde-richting-fout", "label": "Verwart licht-naar-zwaar met zwaar-naar-licht", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-GEW-SCHATTEN-005",
      "familyId": "MET-GEW-SCHATTEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_schatten",
      "questionType": "fill_in",
      "question": "Een pak melk weegt 1 kg. Hoeveel pakken melk heb je nodig om hetzelfde gewicht als een schooltas (~5 kg) te krijgen? Typ het getal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["5"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gewicht vergelijken met referentie",
            "content": "Een pak melk = 1 kg. Een schooltas = ~5 kg. Dus: 5 kg ÷ 1 kg = 5 pakken melk.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "weight_estimate_reference_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Een pak melk weegt 1 kg. Een schooltas weegt ~5 kg. Dus: 5 kg ÷ 1 kg = 5 pakken melk.",
        "solutionSteps": [
          "Pak melk = 1 kg",
          "Schooltas = ~5 kg",
          "5 kg ÷ 1 kg = 5 pakken melk"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.gewicht-referentie-deling-fout", "label": "Maakt fout bij delen om met referentiegewicht te vergelijken" }
        ]
      }
    }
  ]
}